// m покрывает и 4 колонки на десктопе, и 2 на мобильной
export const ROBOT_IMAGE_ALIAS = 'm' as const;
